import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";

export const getAllActiveBlog = createAsyncThunk(
  "Blog/FindAllActiveBlog",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Blog/FindAllActiveBlog`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllActiveBlog() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Blog/FindAllActiveBlog`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export const getBlogByURL = createAsyncThunk(
  "Blog/BlogFindByURL",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/BlogFindByURL`,
        { BlogURL: URL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog By URL:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchBlogByURL(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Blog/BlogFindByURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
      body: JSON.stringify({ BlogURL: URL }),
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}
